// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--HX1uE";
export var pagination = "index-module--pagination--lf3Qt";
export var page = "index-module--page--TV-uC";
export var fadein = "index-module--fadein--fSRZo";